{
  "version": 8,
  "name": "NLS Basemap",
  "center": [
    21.645,
    63.101
  ],
  "zoom": 11.35,
  "sources": {
    "taustakartta": {
      "type": "vector",
      "url": "https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/tilejson/taustakartta/1.0.0/taustakartta/default/v21/WGS84_Pseudo-Mercator/tilejson.json?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"
    },
    "rasteritaustakartta": {
      "type": "raster",
      "tileSize": 256,
      "tiles": [
        "https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/taustakartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2"
      ]
    }
  },
  "glyphs": "https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/glyphs/{fontstack}/{range}.pbf?api-key=7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2",
  "layers": [
    {
      "id": "background",
      "type": "background",
      "paint": {
        "background-color": "white"
      }
    },
 
   
    {
      "id": "vesisto_alue_reuna",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "vesisto_alue",
      "paint": {
        "line-color": "#9ec9e8",
        "line-width": 0.5
      }
    },
   
 
    {
      "id": "vesisto_alue",
      "type": "fill",
      "source": "taustakartta",
      "source-layer": "vesisto_alue",
      "paint": {
          "fill-color": "rgba(228,228,228,0.4)",
          "fill-outline-color": "rgba(0,0,0,1)",
          "fill-outline-width": 1
      }
  },

    {
      "id": "vesisto_viiva",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "vesisto_viiva",
      "paint": {
        "line-color": "#caedfb",
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          0.75,
          20,
          30
        ]
      }
    },
   
   

    {
      "id": "lautta ja lossi",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            12151,
            12152
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          6,
          8
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1.5,
          20,
          30
        ]
      }
    },
    {
      "id": "laiva ja venevaylat",
      "type": "line",
      "source": "taustakartta",
      "source-layer": "liikenne",
      "filter": [
        "all",
        [
          "==",
          [
            "geometry-type"
          ],
          "LineString"
        ],
        [
          "match",
          [
            "get",
            "kohdeluokka"
          ],
          [
            16511,
            16512
          ],
          true,
          false
        ]
      ],
      "layout": {},
      "paint": {
        "line-color": "#ccc",
        "line-dasharray": [
          6,
          8
        ],
        "line-width": [
          "interpolate",
          [
            "exponential",
            1.55
          ],
          [
            "zoom"
          ],
          6,
          1,
          20,
          20
        ]
      }
    },

    {
      "id": "nimisto-maasto-vedet",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "match",
        [
          "get",
          "teema"
        ],
        [
          "Maasto",
          "Vedet"
        ],
        true,
        false
      ],
      "layout": {
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "text-font": [
          "match",
          [
            "get",
            "teema"
          ],
          "Vedet",
          [
            "literal",
            [
              "Liberation Sans NLSFI Left"
            ]
          ],
          "Maasto",
          [
            "literal",
            [
              "Liberation Sans NLSFI Right"
            ]
          ],
          [
            "literal",
            [
              "Liberation Sans NLSFI"
            ]
          ]
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          1,
          [
            "step",
            [
              "get",
              "prioriteetti"
            ],
            20,
            3,
            16
          ],
          10,
          [
            "step",
            [
              "get",
              "prioriteetti"
            ],
            20,
            4,
            14
          ],
          16,
          [
            "step",
            [
              "get",
              "prioriteetti"
            ],
            22,
            5,
            12
          ]
        ],
        "visibility": "visible"
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgba(255, 255, 255, 1)",
        "text-color": [
          "match",
          [
            "get",
            "teema"
          ],
          "Vedet",
          "hsl(251, 71%, 50%)",
          "hsl(0, 0%, 20%)"
        ],
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "all",
        [
          "!",
          [
            "match",
            [
              "get",
              "teema"
            ],
            [
              "Maasto",
              "Vedet"
            ],
            true,
            false
          ]
        ],
        [
          "!=",
          [
            "get",
            "alaryhma"
          ],
          "Hallintoalueet"
        ],
        [
          "match",
          [
            "get",
            "laji"
          ],
          [
            "Kansallispuisto",
            "Luonnonpuisto"
          ],
          false,
          true
        ]
      ],
      "layout": {
        "text-transform": [
          "match",
          [
            "get",
            "alaryhma"
          ],
          "Rautatieliikennepaikat",
          "uppercase",
          "none"
        ],
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "icon-ignore-placement": true,
        "icon-allow-overlap": true,
        "text-font": [
          "Liberation Sans NLSFI"
        ],
        "text-size": [
          "interpolate",
          [
            "linear"
          ],
          [
            "zoom"
          ],
          1,
          [
            "interpolate",
            [
              "linear"
            ],
            [
              "get",
              "prioriteetti"
            ],
            1,
            20,
            3,
            16
          ],
          10,
          [
            "interpolate",
            [
              "linear"
            ],
            [
              "get",
              "prioriteetti"
            ],
            5,
            16,
            7,
            13
          ],
          14,
          [
            "interpolate",
            [
              "linear"
            ],
            [
              "get",
              "prioriteetti"
            ],
            5,
            22,
            10,
            12
          ]
        ],
        "visibility": "visible"
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgba(255, 255, 255, 1)",
        "text-color": [
          "match",
          [
            "get",
            "teema"
          ],
          "Vedet",
          "hsl(251, 71%, 50%)",
          "Suojellut kohteet",
          "hsl(117, 79%, 31%)",
          "hsl(0, 0%, 15%)"
        ],
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto_luonnopuistot",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "match",
        [
          "get",
          "laji"
        ],
        [
          "Kansallispuisto",
          "Luonnonpuisto"
        ],
        true,
        false
      ],
      "layout": {
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "icon-ignore-placement": true,
        "icon-allow-overlap": false,
        "text-font": [
          "Liberation Sans NLSFI"
        ],
        "visibility": "visible"
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgba(255, 255, 255, 1)",
        "text-color": "hsl(117, 79%, 31%)",
        "text-halo-blur": 1
      }
    },
    {
      "id": "nimisto_kunnat",
      "type": "symbol",
      "source": "taustakartta",
      "source-layer": "nimisto",
      "filter": [
        "all",
        [
          "==",
          [
            "get",
            "alaryhma"
          ],
          "Hallintoalueet"
        ],
        [
          "==",
          [
            "get",
            "laji"
          ],
          "Kunta"
        ]
      ],
      "layout": {
        "text-field": [
          "coalesce",
          [
            "get",
            "nimi_fin"
          ],
          [
            "get",
            "nimi_swe"
          ],
          [
            "get",
            "nimi_sme"
          ],
          [
            "get",
            "nimi_sms"
          ],
          [
            "get",
            "nimi_smn"
          ]
        ],
        "icon-ignore-placement": false,
        "icon-allow-overlap": false,
        "text-size": [
          "interpolate",
          [
            "exponential",
            1.35
          ],
          [
            "zoom"
          ],
          1,
          16,
          14,
          28
        ],
        "text-font": [
          "step",
          [
            "zoom"
          ],
          [
            "literal",
            [
              "Liberation Sans NLSFI"
            ]
          ],
          6,
          [
            "literal",
            [
              "Liberation Sans NLSFI Bold"
            ]
          ]
        ]
      },
      "paint": {
        "text-halo-width": 2,
        "text-halo-color": "rgb(255, 255, 255)",
        "text-color": "hsl(0, 0%, 25%)",
        "text-halo-blur": 1
      }
    }
  ],
  "id": "NLS-Basemap"
}